<nav class="navbar navbar-expand-lg ak-nav-a">
    <div class="container-fluid">

        <app-logo-img  (click)="redirectHome()" [theme]="env?.theme?.logoConf?.themeColorNav" [type]="env?.theme?.logoConf?.typeNav"></app-logo-img>
        <div class="navbar-nav" >
            <a class="active-cursor nav-item nav-link text-primary " (click)="login()">Login</a>
        </div>
    </div>
</nav>